import { deviceType } from "@tm/static/utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Page = styled.div`
  background: ${theme.smokeWhite};
  min-height: 100vh;
`;

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 16px;

  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const TopSection = styled.div`
  padding: 24px 0 0;

  @media ${deviceType.mobile} {
    padding: 16px 16px 0;
  }
`;

export const Body = styled.div`
  padding: 24px 0 40px;

  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;

  @media ${deviceType.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StepFlowCard = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${deviceType.mobile} {
    padding: 16px;
    gap: 16px;
  }
`;

export const StepProgressLabel = styled.div`
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
  color: ${theme.greyText};
  margin-bottom: 10px;
`;

export const StepProgressBars = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StepProgressBar = styled.div<{ $active?: boolean }>`
  height: 4px;
  width: 24px;
  border-radius: 999px;
  background: ${(props) =>
    props.$active ? theme.greenText5 : theme.greyText2};
`;

export const StepFlowContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StepFlowFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const StepFlowFooterPrimary = styled.div`
  margin-left: auto;
`;

export const PwaStepFlowBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 96px;
`;

export const PwaStickyFooter = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${theme.whiteText};
  border-top: 1px solid ${theme.gainsBoro};
  padding: 12px 16px env(safe-area-inset-bottom);
  display: flex;
  gap: 12px;
  z-index: 10;
`;

export const PwaStickyFooterPrimary = styled.div`
  flex: 1;
`;
